import React from 'react';
import styled from 'styled-components';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import { panelAccent, panelAccentAlpha } from 'theme/panelAccent';

/**
 * Cabeçalho das três formas de colocar produto no evento (modelos, sugestões,
 * criar do zero). Antes cada bloco tinha seu próprio título solto separado por
 * linha tracejada, todos com o mesmo peso — não dava pra saber o que era o quê
 * nem quantos itens tinha em cada um. Aqui todos ganham ícone, contagem e uma
 * linha explicando pra que serve aquele caminho.
 */
export default function StepSection({
    id,
    icon: Icon,
    title,
    hint,
    count,
    badge = null,
    action = null,
    children,
}) {
    const headingId = `${id}-heading`;

    return (
        <Section aria-labelledby={headingId}>
            <Header>
                <HeaderText>
                    <HeaderTop>
                        <HeaderIcon>
                            <Icon size={16} aria-hidden='true' />
                        </HeaderIcon>
                        <Title id={headingId}>{title}</Title>
                        {badge}
                        {count > 0 && <Count>{count}</Count>}
                    </HeaderTop>
                    {!!hint && <Hint>{hint}</Hint>}
                </HeaderText>

                {action}
            </Header>

            {children}
        </Section>
    );
}

const Section = styled.section`
    & + & {
        margin-top: 34px;
    }
`;

const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 14px;

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        gap: 16px;
    }
`;

const HeaderText = styled.div`
    min-width: 0;
`;

const HeaderTop = styled.div`
    display: flex;
    align-items: center;
    gap: 9px;
`;

const HeaderIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 9px;
    flex-shrink: 0;
    background: ${panelAccentAlpha(colors.occasionalPurple, '12')};
    color: ${panelAccent(colors.occasionalPurple)};
`;

const Title = styled.h3`
    font-size: 15px;
    font-weight: 600;
    color: ${colors.nightDark};
`;

const Count = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 21px;
    height: 21px;
    padding: 0 7px;
    border-radius: 11px;
    background: ${panelAccentAlpha(colors.occasionalPurple, '18')};
    color: ${panelAccent(colors.occasionalPurple)};
    font-size: 11px;
    font-weight: 600;
`;

const Hint = styled.p`
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.45;
    color: ${colors.night};
`;
